<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-input prefix-icon="el-icon-search" clearable v-model="searchText" style="width: 260px"></el-input>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
    </div>
    <el-table :data="organList" class="table-border" v-loading="$store.state.organ.organList.length === 0"
              header-cell-class-name="table-head">
      <el-table-column label="机构代码" prop="exposedCode"></el-table-column>
      <el-table-column label="机构名称" prop="name"></el-table-column>
      <el-table-column label="机构类型">
        <template #default="{row}">
          <div>{{row.type | valueName('OrganType')}}</div>
        </template>
      </el-table-column>
      <el-table-column label="品牌">
        <template #default="{row}">
          <label v-if="row.carBandIds">
            {{row.carBandIds.map(id => brandNameMap[id] ? brandNameMap[id] : id).join()}}
          </label>
        </template>
      </el-table-column>
      <el-table-column label="联系人" prop="contactName"></el-table-column>
      <el-table-column label="联系号码" prop="cellphone"></el-table-column>
      <el-table-column label="详细地址" prop="addressDetail"></el-table-column>
      <el-table-column label="状态" width="60">
        <template #default="{row}">
          <div>{{row.status | status}}</div>
        </template>
      </el-table-column>

      <el-table-column :width="deletable ? 70 : 80" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && !deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button v-if="isRoot" type="text" @click="edit(row)" size="mini">编辑</el-button>
          <el-button v-else type="text" @click="edit(row)" size="mini">
            {{(readOnly || !row.editable) ? '查看' : '编辑'}}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column :width="deletable ? 80: 1" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button v-if="isRoot" type="text" @click="deleteOrgan(row)" size="mini" class="danger">删除</el-button>
          <el-button v-else :disabled="!row.editable" type="text" size="mini" @click="deleteOrgan(row)"
                     class="danger">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <edit-organ-dialog :visible.sync="dialog.show"
                       :read-only="!isRoot && (readOnly || !dialog.organ.editable)"
                       :organ="dialog.organ"></edit-organ-dialog>
  </div>
</template>

<script>
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import EditOrganDialog from '@/views/organ/EditOrganDialog'
  import { Organ } from '@/store/objdef/objectDef'
  import authority from '@/utils/authority'

  export default {
    name: 'OrganList',
    components: { EditOrganDialog },
    mixins: [shareDataMixin],
    data () {
      return {
        searchText: null,
        dialog: {
          show: false,
          organ: new Organ()
        }
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.$store.dispatch('organ/all')
      },
      add () {
        this.dialog.organ = new Organ()
        this.dialog.show = true
      },
      edit (organ) {
        this.dialog.organ = this.$_.cloneDeep(organ)
        this.dialog.show = true
      },
      deleteOrgan (organ) {
        this.$confirm(`确认删除机构【${organ.name}】, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('organ/delete', organ).then(() => {
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      }
    },
    computed: {
      organList () {
        const list = this.$store.state.organ.organList
        if (!this.searchText) return list

        return list.filter(organ => organ.name.indexOf(this.searchText) !== -1)
      },
      readOnly () {
        return !this.$hasPermission(authority.EDIT_ORGAN)
      },
      addable () {
        return this.$hasPermission(authority.ADD_ORGAN)
      },
      deletable () {
        return this.$hasPermission(authority.DELETE_ORGAN)
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ th {
    height: 50px;
  }
</style>
